<svg
  [attr.width]="width"
  [attr.height]="height"
  [attr.class]="class"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  [attr.stroke-width]="strokeWidth"
  stroke-linecap="round"
  stroke-linejoin="round">

  <!-- Plus Icon -->
  <ng-container *ngIf="name === 'plus'">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </ng-container>

  <!-- Close Icon -->
  <ng-container *ngIf="name === 'close'">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </ng-container>

  <!-- Edit Icon -->
  <ng-container *ngIf="name === 'edit'">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </ng-container>

  <!-- Delete Icon -->
  <ng-container *ngIf="name === 'delete'">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </ng-container>

  <!-- Search Icon -->
  <ng-container *ngIf="name === 'search'">
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </ng-container>

  <!-- Chevron Down -->
  <ng-container *ngIf="name === 'chevron-down'">
    <polyline points="6 9 12 15 18 9"></polyline>
  </ng-container>

  <!-- Chevron Up -->
  <ng-container *ngIf="name === 'chevron-up'">
    <polyline points="18 15 12 9 6 15"></polyline>
  </ng-container>

  <!-- Checkmark -->
  <ng-container *ngIf="name === 'checkmark'">
    <polyline points="20 6 9 17 4 12"></polyline>
  </ng-container>

  <!-- Clear (X in circle) -->
  <ng-container *ngIf="name === 'clear'">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </ng-container>

  <!-- Copy/Duplicate Icon -->
  <ng-container *ngIf="name === 'copy'">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </ng-container>

  <!-- Dollar Icon -->
  <ng-container *ngIf="name === 'dollar'">
    <line x1="12" y1="1" x2="12" y2="23"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  </ng-container>

  <!-- Eye Icon -->
  <ng-container *ngIf="name === 'eye'">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </ng-container>

  <!-- Info Icon -->
  <ng-container *ngIf="name === 'info'">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </ng-container>

  <!-- Arrow Right Icon -->
  <ng-container *ngIf="name === 'arrow-right'">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </ng-container>

  <!-- Arrow Left Icon -->
  <ng-container *ngIf="name === 'arrow-left'">
    <path d="M19 12H5"></path>
    <path d="M12 19l-7-7 7-7"></path>
  </ng-container>

  <!-- Refresh Icon -->
  <ng-container *ngIf="name === 'refresh'">
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
    <path d="M21 3v5h-5"></path>
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
    <path d="M3 21v-5h5"></path>
  </ng-container>

  <!-- Users Icon -->
  <ng-container *ngIf="name === 'users'">
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
    <circle cx="19" cy="7" r="2" />
    <path d="M23 21v-1a2 2 0 00-2-2h-2" />
  </ng-container>

  <!-- Upload Icon -->
  <ng-container *ngIf="name === 'upload'">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  </ng-container>

  <!-- Alert Circle Icon -->
  <ng-container *ngIf="name === 'alert-circle'">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </ng-container>

  <!-- Image Icon -->
  <ng-container *ngIf="name === 'image'">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21,15 16,10 5,21"></polyline>
  </ng-container>

  <!-- Grid Icon -->
  <ng-container *ngIf="name === 'grid'">
    <rect x="3" y="3" width="7" height="7" rx="1"></rect>
    <rect x="14" y="3" width="7" height="7" rx="1"></rect>
    <rect x="3" y="14" width="7" height="7" rx="1"></rect>
    <rect x="14" y="14" width="7" height="7" rx="1"></rect>
  </ng-container>

  <!-- Building Icon -->
  <ng-container *ngIf="name === 'building'">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </ng-container>

  <!-- Map Pin Icon -->
  <ng-container *ngIf="name === 'map-pin'">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </ng-container>

  <!-- User Icon -->
  <ng-container *ngIf="name === 'user'">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </ng-container>

  <!-- Settings Icon -->
  <ng-container *ngIf="name === 'settings'">
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M12 1v6m0 6v6m8.66-10l-5.2 3m-3.46 2l-5.2 3m0-12l5.2 3m3.46 2l5.2 3"></path>
  </ng-container>

  <!-- Box/Empty State Icon -->
  <ng-container *ngIf="name === 'box'">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="9" y1="3" x2="9" y2="21"></line>
  </ng-container>

  <!-- Download Icon -->
  <ng-container *ngIf="name === 'download'">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </ng-container>

  <!-- Check Circle Icon -->
  <ng-container *ngIf="name === 'check-circle'">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="16 8 10 14 8 12"></polyline>
  </ng-container>

  <!-- Clock Icon -->
  <ng-container *ngIf="name === 'clock'">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </ng-container>

  <!-- X Circle Icon -->
  <ng-container *ngIf="name === 'x-circle'">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </ng-container>

  <!-- Send Icon -->
  <ng-container *ngIf="name === 'send'">
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  </ng-container>

  <!-- Credit Card Icon -->
  <ng-container *ngIf="name === 'credit-card'">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
    <line x1="1" y1="10" x2="23" y2="10"></line>
  </ng-container>

  <!-- File Icon -->
  <ng-container *ngIf="name === 'file'">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
  </ng-container>

  <!-- More Vertical Icon (three dots) -->
  <ng-container *ngIf="name === 'more-vertical'">
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="5" r="1"></circle>
    <circle cx="12" cy="19" r="1"></circle>
  </ng-container>

  <!-- Bell Icon -->
  <ng-container *ngIf="name === 'bell'">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  </ng-container>
</svg>
